module.exports = __webpack_public_path__ + "img/banner-1.b26146b9.png";